export default __webpack_public_path__ + "static/media/wallet.0aecac1d.png";